import React from "react";

import styled from "styled-components/macro";

import { Body, Link, Title, TitleIcon, TitleWrapper, Wrapper } from "./Styles";

export default function OurMission({ show }) {
  if (!show) return null;

  return (
    <StyledWrapper>
      <TitleWrapper>
        <TitleIcon>
          <i className="far fa-check-square" />
        </TitleIcon>
        <Title>Our Mission</Title>
      </TitleWrapper>
      <Body>
        We&apos;re on a mission to build a more connected church. We&apos;ve
        established some strongly held beliefs which shape our unique company
        culture and radical commitment to loving our customers, partners, and
        team members.
      </Body>
      <Link
        href="https://flocknote.com/our-mission/"
        target="_blank"
        rel="noreferrer"
      >
        Flocknote&apos;s Guiding Principles &gt;
      </Link>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  margin-top: -14px;
  background-color: none;
  box-shadow: none;
`;
